module.exports = __webpack_public_path__ + "static/media/orinocco37.a30900df.jpg";